import React from 'react';
import { useRouter } from 'next/router';

import * as nationalCertificateResult from 'modules/national-certificate-result';

import { QuestionTypeEnum } from '../constants';

import ComplexWithSubsTest from './complex-with-subs-test';
import ExclusiveSubsTest from './exclusive-subs-test';
import Header from './header';
import InputTest from './input-test';
import SimpleQuestion from './simple-test';
import { TestSkeleton } from './skeleton';

export const Main = () => {
  const { query } = useRouter();
  const { results, isLoading } = nationalCertificateResult.useResult(query?.ticketId as string);

  const componentsMap = {
    simple: SimpleQuestion,
    complex_with_input: InputTest,
    complex_with_subs: ComplexWithSubsTest,
    exclusive_subs: ExclusiveSubsTest
  };

  if (isLoading) {
    return <TestSkeleton />;
  }

  return (
    <>
      <div className="my-10 space-y-5">
        <Header total={results?.ticket?.test?.questions?.length} incorrect={results?.false} correct={results?.right} />
        {results?.ticket?.test?.questions.map(question => {
          const Component = componentsMap[question.type as QuestionTypeEnum];

          return Component ? <Component subject={results?.ticket?.test?.name} key={question.question_id} data={question} /> : null;
        })}
      </div>
    </>
  );
};
